import { RefreshCw, X } from 'lucide-react';
import { useState } from 'react';
import { applyUpdate, usePwa } from '../state/pwa';

/** Offers to reload into a newer version once it has been downloaded (see state/pwa.ts). */
export function UpdateNotice() {
  const update = usePwa((s) => s.update);
  const [dismissed, setDismissed] = useState<ServiceWorker | null>(null);
  if (!update || update === dismissed) return null;
  return (
    <div
      role="status"
      className="fixed right-3 bottom-9 z-50 flex max-w-[calc(100vw-1.5rem)] items-center gap-1 rounded-lg border border-border-strong bg-panel-2 py-1 pr-1 pl-3 text-[12.5px] text-text shadow-[var(--shadow-pop)]"
    >
      <span className="min-w-0">A new version of modelviewer is ready.</span>
      <button
        onClick={applyUpdate}
        className="flex flex-none items-center gap-1.5 rounded-md px-2 py-1 font-medium text-accent hover:bg-hover pointer-coarse:py-2.5"
      >
        <RefreshCw size={13} /> Reload
      </button>
      <button
        onClick={() => setDismissed(update)}
        className="flex h-7 w-7 flex-none items-center justify-center rounded-md text-muted hover:bg-hover hover:text-text pointer-coarse:h-9 pointer-coarse:w-9"
        aria-label="Not now"
        title="Not now"
      >
        <X size={14} />
      </button>
    </div>
  );
}
